<template lang="pug">
.page-area(:style="style" ref="area")
    template(v-if="areaIsDisabled")
        include area-title-bar.pug
        p.area-status-info {{ $t('Area is disabled!') }}
        //- el-alert.unsupported(
        //-     :title="$t('Area is disabled!')"
        //-     type="warning"
        //-     effect="dark"
        //-     :closable="false"
        //- )
    template(v-else-if="!areaIsSupported")
        include area-title-bar.pug
        p.area-status-info {{ $t('Area is not supported!') }}
        //- el-alert.unsupported(
        //-     :title="$t('Area is not supported!')"
        //-     type="warning"
        //-     effect="dark"
        //-     :closable="false"
        //- )
    template(v-else)
        .sticky-container
            include area-title-bar.pug
            .sections(:class="{ 'is-dragging': dragging, 'is-dragging-new': !!draggingNewSection }")
                //- NOTE: empty-area drop zone lives OUTSIDE <draggable>; otherwise its v-if=false comment VNode
                //- shifts vuedraggable's visibleIndexes by 1 and SortableJS drops land at the wrong array index.
                .new-section-placeholder.empty-area-drop-zone(
                    v-if="draggingNewSection && !sections.length"
                    :class="{ 'is-active': dragOverPosition === 'empty' }"
                    @dragover.prevent="dragOverPosition = 'empty'"
                    @dragleave="onDropZoneLeave($event, 'empty')"
                    @drop.prevent="dropNewSection(0)"
                )
                    section.section.ghost.first
                        a(href="#" @click.prevent)
                            h4(v-html="$t('section.add.drop', { section: draggingNewSection.name })")
                //- NOTE: draggable only inside (grid) areas own scope
                //- :group="`${[...sectionsAddress, key].join('.')}:sections`"
                //- NOTE: draggable inside page areas scope and all containing grid areas
                //- :group="`${sectionsAddress[0]}:sections`"
                draggable.droppable(
                    ref="droppable"
                    v-model="sections"
                    group="sections"
                    :disabled="pendingSection !== undefined || (copiedSection && canPasteHere) || !!draggingNewSection"
                    :data-allowed-sections="JSON.stringify(sectionOptions.map((el) => el.key))"
                    :data-allowed-grids="JSON.stringify(gridOptions.map((el) => el.key))"
                    :move="checkMove"
                    @start="$emit('dragging', true)"
                    @end="$emit('dragging', false)"
                    @add="dropped"
                    handle="h4.handle"
                )
                    //- transition-group(name="slide-vertical" type="transition" tag="ul" class="no-style-list")
                    .li(v-if="sections.length" v-for="(section, index) in sections" :key="section.id")
                        //- pre {{ section.position }}
                        //- pre {{ section.id }}
                        transition(name="slide-left")
                            .new-section-placeholder(
                                v-if="draggingNewSection && index === 0"
                                :class="{ 'is-active': dragOverPosition === 'before-0' }"
                                @dragover.prevent="dragOverPosition = 'before-0'"
                                @dragleave="onDropZoneLeave($event, 'before-0')"
                                @drop.prevent="dropNewSection(0)"
                            )
                                section.section.ghost.first
                                    a(href="#" @click.prevent)
                                        h4(v-html="$t('section.add.drop', { section: draggingNewSection.name })")
                        transition(name="slide-left")
                            .new-section-placeholder(v-if="(pendingSection || (copiedSection && canPasteHere)) && index === 0")
                                section.section.ghost.first
                                    a(v-if="copiedSection && canPasteHere" href="#" @click="event => pasteSection(event, 1)")
                                        h4(v-html="$t('section.paste.click', { section: copiedSection.sectionName })")
                                    a(v-else href="#" @click="event => addSection(event, 0, pendingSection)")
                                        h4(v-html="$t('section.add.click', { section: pendingSection.name })")
                                    el-button.cancel-placeholder(
                                        type="text"
                                        size="mini"
                                        @click.stop="cancelPaste"
                                    )
                                        i.el-icon-fa-xmark.fas
                        template(v-if="section.type === 'grid'")
                            Grid(
                                v-if="section.gridAreas && section.gridAreas.length"
                                :section="section"
                                :page="form"
                                :section-config="getGridConfig(section.key)"
                                :root-area-config="config"
                                :options="options"
                                :sortable="! pendingSection && !(copiedSection && canPasteHere)"
                                :edit="editSection && editSection.id === section.id"
                                :saveable="saveable"
                                :saving="savingSection && savingSection.id === section.id"
                                :disabled="!gridIsSupported(section.key)"

                                :dragging="dragging"
                                :sections-address="[...sectionsAddress, getSectionIndex(section)]"
                                :area-section-options="sectionOptions"
                                :area-grid-options="gridOptions"

                                :trigger-update-grid-positions="updateGridPositions === section.id"

                                @dragging="value => $emit('dragging', value)"

                                @delete:grid="grid => openDeleteDialog(grid, 'grid')"
                                @edit:grid="editSection = section"

                                @save="(data) => saveSection(section, data)"
                                @apply="(data) => applySection(section, data)"
                                @cancel="editSection = undefined"

                                @add:area="data => openGridAreaDrawer({ grid: section, ...data }, 'create')"
                                @edit:area="data => openGridAreaDrawer({ grid: section, ...data }, 'edit')"
                                @delete:area="area => openDeleteDialog({ area, grid: section }, 'area')"
                            )
                        template(v-else)
                            component(
                                :is="getSectionComponent(section.key)"
                                :section="section"
                                :page="form"
                                :section-config="getSectionConfig(section.key)"
                                :options="options"
                                :sortable="! pendingSection && !(copiedSection && canPasteHere)"
                                :edit="editSection && editSection.id === section.id"
                                :hide="hide"
                                :saveable="saveable"
                                :saving="savingSection && savingSection.id === section.id"
                                :disabled="!sectionIsSupported(section.key) || sectionIsDisabled(section.key) || !sectionIsVisible(section.key) || sectionIsNotPermitted(section.key)"
                                @edit="editSection = section"
                                @save="(data) => saveSection(section, data)"
                                @apply="(data) => applySection(section, data)"
                                @cancel="editSection = undefined"
                                @delete="openDeleteDialog"
                            )
                                el-alert.unsupported(
                                    v-if="!sectionIsSupported(section.key)"
                                    :title="$t('Content element is not supported!')"
                                    type="warning"
                                    effect="dark"
                                    :closable="false"
                                )
                                el-alert.unsupported(
                                    v-else-if="sectionIsDisabled(section.key)"
                                    :title="$t('Content element is disabled!')"
                                    type="warning"
                                    effect="dark"
                                    :closable="false"
                                )
                                el-alert.unsupported(
                                    v-else-if="!sectionIsVisible(section.key)"
                                    :title="$t('Content element is not activated!')"
                                    type="warning"
                                    effect="dark"
                                    :closable="false"
                                )
                                el-alert.unsupported(
                                    v-else-if="sectionIsNotPermitted(section.key)"
                                    :title="$t('Insufficient permissions')"
                                    type="info"
                                    effect="dark"
                                    :closable="false"
                                )
                            //- MapBox(
                            //-     v-else-if="section.key === 'mapbox'"
                            //-     :section="section"
                            //-     :section-config="getSectionConfig(section.key)"
                            //-     :options="options"
                            //-     :sortable="! pendingSection"
                            //-     :disabled="sectionIsDisabled(section.key)"
                            //-     :force-edit="editSection && editSection.id === section.id"
                            //- )
                            //-     el-alert.unsupported(
                            //-         v-if="!sectionIsSupported(section.key)"
                            //-         :title="$t('Content element is not supported!')"
                            //-         type="warning"
                            //-         effect="dark"
                            //-         :closable="false"
                            //-     )
                            //-     el-alert.unsupported(
                            //-         v-else-if="sectionIsDisabled(section.key)"
                            //-         :title="$t('Content element is disabled!')"
                            //-         type="warning"
                            //-         effect="dark"
                            //-         :closable="false"
                            //-     )
                            //- Form(
                            //-     v-else-if="section.key === 'form'"
                            //-     :section="section"
                            //-     :section-config="getSectionConfig(section.key)"
                            //-     :options="options"
                            //-     :sortable="! pendingSection"
                            //-     :disabled="sectionIsDisabled(section.key)"
                            //-     :force-edit="editSection && editSection.id === section.id"
                            //- )
                            //-     el-alert.unsupported(
                            //-         v-if="!sectionIsSupported(section.key)"
                            //-         :title="$t('Content element is not supported!')"
                            //-         type="warning"
                            //-         effect="dark"
                            //-         :closable="false"
                            //-     )
                            //-     el-alert.unsupported(
                            //-         v-else-if="sectionIsDisabled(section.key)"
                            //-         :title="$t('Content element is disabled!')"
                            //-         type="warning"
                            //-         effect="dark"
                            //-         :closable="false"
                            //-     )
                            //- CategoryPosts(
                            //-     v-else-if="section.key === 'categoryposts'"
                            //-     :module="module"
                            //-     :page="page"
                            //-     :section="section"
                            //-     :section-config="getSectionConfig(section.key)"
                            //-     :sortable="! pendingSection"
                            //- )
                            //-     el-alert.unsupported(
                            //-         v-if="!sectionIsSupported(section.key)"
                            //-         :title="$t('Content element is not supported!')"
                            //-         type="warning"
                            //-         effect="dark"
                            //-         :closable="false"
                            //-     )
                            //-     el-alert.unsupported(
                            //-         v-else-if="sectionIsDisabled(section.key)"
                            //-         :title="$t('Content element is disabled!')"
                            //-         type="warning"
                            //-         effect="dark"
                            //-         :closable="false"
                            //-     )
                            //- Events(
                            //-     v-else-if="section.key === 'events'"
                            //-     :module="module"
                            //-     :page="page"
                            //-     :section="section"
                            //-     :section-config="getSectionConfig(section.key)"
                            //-     :sortable="! pendingSection"
                            //- )
                            //-     el-alert.unsupported(
                            //-         v-if="!sectionIsSupported(section.key)"
                            //-         :title="$t('Content element is not supported!')"
                            //-         type="warning"
                            //-         effect="dark"
                            //-         :closable="false"
                            //-     )
                            //-     el-alert.unsupported(
                            //-         v-else-if="sectionIsDisabled(section.key)"
                            //-         :title="$t('Content element is disabled!')"
                            //-         type="warning"
                            //-         effect="dark"
                            //-         :closable="false"
                            //-     )
                            //- Evaluation(
                            //-     v-else-if="section.key === 'evaluation'"
                            //-     :module="module"
                            //-     :page="page"
                            //-     :section="section"
                            //-     :section-config="getSectionConfig(section.key)"
                            //-     :sortable="! pendingSection"
                            //- )
                            //-     el-alert.unsupported(
                            //-         v-if="!sectionIsSupported(section.key)"
                            //-         :title="$t('Content element is not supported!')"
                            //-         type="warning"
                            //-         effect="dark"
                            //-         :closable="false"
                            //-     )
                            //-     el-alert.unsupported(
                            //-         v-else-if="sectionIsDisabled(section.key)"
                            //-         :title="$t('Content element is disabled!')"
                            //-         type="warning"
                            //-         effect="dark"
                            //-         :closable="false"
                            //-     )
                            //- CategoryProducts(
                            //-     v-else-if="section.key === 'categoryproducts'"
                            //-     :module="module"
                            //-     :page="page"
                            //-     :section="section"
                            //-     :section-config="getSectionConfig(section.key)"
                            //-     :sortable="! pendingSection"
                            //- )
                            //-     el-alert.unsupported(
                            //-         v-if="!sectionIsSupported(section.key)"
                            //-         :title="$t('Content element is not supported!')"
                            //-         type="warning"
                            //-         effect="dark"
                            //-         :closable="false"
                            //-     )
                            //-     el-alert.unsupported(
                            //-         v-else-if="sectionIsDisabled(section.key)"
                            //-         :title="$t('Content element is disabled!')"
                            //-         type="warning"
                            //-         effect="dark"
                            //-         :closable="false"
                            //-     )
                            //- Products(
                            //-     v-else-if="section.key === 'products'"
                            //-     :module="module"
                            //-     :page="page"
                            //-     :section="section"
                            //-     :section-config="getSectionConfig(section.key)"
                            //-     :sortable="! pendingSection"
                            //- )
                            //-     el-alert.unsupported(
                            //-         v-if="!sectionIsSupported(section.key)"
                            //-         :title="$t('Content element is not supported!')"
                            //-         type="warning"
                            //-         effect="dark"
                            //-         :closable="false"
                            //-     )
                            //-     el-alert.unsupported(
                            //-         v-else-if="sectionIsDisabled(section.key)"
                            //-         :title="$t('Content element is disabled!')"
                            //-         type="warning"
                            //-         effect="dark"
                            //-         :closable="false"
                            //-     )
                            //- Section(
                            //-     v-else
                            //-     :section="section"
                            //-     :section-config="getSectionConfig(section.key)"
                            //-     :options="options"
                            //-     :sortable="! pendingSection"
                            //-     :disabled="sectionIsDisabled(section.key)"
                            //-     :force-edit="editSection && editSection.id === section.id"
                            //- )
                            //-     el-alert.unsupported(
                            //-         v-if="!sectionIsSupported(section.key)"
                            //-         :title="$t('Content element is not supported!')"
                            //-         type="warning"
                            //-         effect="dark"
                            //-         :closable="false"
                            //-     )
                            //-     el-alert.unsupported(
                            //-         v-else-if="sectionIsDisabled(section.key)"
                            //-         :title="$t('Content element is disabled!')"
                            //-         type="warning"
                            //-         effect="dark"
                            //-         :closable="false"
                            //-     )
                        transition(name="slide-left")
                            .new-section-placeholder(v-if="pendingSection || (copiedSection && canPasteHere)")
                                section.section.ghost
                                    a(v-if="copiedSection && canPasteHere" href="#" @click="event => pasteSection(event, section.position + 1)")
                                        h4(v-html="$t('section.paste.click', { section: copiedSection.sectionName })")
                                    a(v-else href="#" @click="event => addSection(event, section.position, pendingSection)")
                                        h4(v-html="$t('section.add.click', { section: pendingSection.name })")
                                    el-button.cancel-placeholder(
                                        type="text"
                                        size="mini"
                                        @click.stop="cancelPaste"
                                    )
                                        i.el-icon-fa-xmark.fas
                        transition(name="slide-left")
                            .new-section-placeholder(
                                v-if="draggingNewSection"
                                :class="{ 'is-active': dragOverPosition === `after-${index}` }"
                                @dragover.prevent="dragOverPosition = `after-${index}`"
                                @dragleave="onDropZoneLeave($event, `after-${index}`)"
                                @drop.prevent="dropNewSection(index + 1)"
                            )
                                section.section.ghost
                                    a(href="#" @click.prevent)
                                        h4(v-html="$t('section.add.drop', { section: draggingNewSection.name })")

                    //- li(v-else)
                    //-     .new-section-placeholder(v-if="pendingSection")
                    //-         section.section.ghost.first
                    //-             a(href="#" @click="event => addSection(event, 0, pendingSection)")
                    //-                 h4(v-html="$t('section.add.click', { section: pendingSection.name })")


        .footer-actions
            el-button.is-square(
                v-if="sectionOptions.length || gridOptions.length"
                size="small"
                type="primary"
                icon="el-icon-fa-plus fas"
                :disabled="pendingSection !== undefined || (copiedSection && canPasteHere)"
                @click="addSectionDialogVisible = true"
            )
            .grid-options(v-if="gridOptions.length")
                draggable(
                    :list="gridOptions"
                    :group="{ name: 'sections', pull: 'clone', put: false }"
                    :sort="false"
                    :move="checkMove"
                    @start="startDragging"
                    @end="endDragging"
                    chosen-class="show-custom-ghost"
                    :disabled="pendingSection !== undefined || (copiedSection && canPasteHere)"
                )
                    .li.draggable.page-area-option(v-for="grid in gridOptions" :key="grid.key")
                        el-button.section-option.grid(
                            :plain="pendingSection && pendingSection !== grid"
                            type="info"
                            size="small"
                            @click="event => setPendingSection(event, grid)"
                        )
                            span.grid-btn-icon(v-html="getGridSvg(grid.key)")
                            span {{ grid.name }}
                        section.section.grid.ghost
                            h4(v-html="$t('section.add.drop', { section: grid.name })")

        add-section-dialog(
            :visible.sync="addSectionDialogVisible"
            :section-options="sectionOptions"
            :grid-options="gridOptions"
            @select="section => setPendingSection(null, section)"
            @drag-start="onNewSectionDragStart"
        )


    el-drawer.grid-area-drawer.full-height-drawer.visible-overflow(
        :title="gridAreaDrawer.title"
        :visible.sync="gridAreaDrawer.visibility"
        :before-close="confirmDiscard(() => changedSince(gridAreaDrawer.formSnapshot, gridAreaDrawer.form))"
        :wrapper-closable="false"
        :append-to-body="true"
        size="920px"
        :modal="true"
        @closed="resetAreaSettingsDrawer"
    )
        .drawer-body(v-loading="gridAreaDrawer.loading")
            el-form(
                v-if="gridAreaDrawer.form"
                label-position="top"
                :model="gridAreaDrawer.form"
                :rules="gridAreaDrawer.rules"
                ref="grid-area-drawer-form"
            )
                //- :class="{ 'full-height': !gridAreaDrawer.form.position }"
                .position(
                    v-if="gridAreaDrawer.action === 'create'"
                )
                    el-form-item(:label="$t('Position')" prop="position")
                        el-checkbox.hidden(:value="!!gridAreaDrawer.form.position")
                        template(v-if="!gridAreaDrawer.form.position")
                            grid-preview(
                                v-if="gridAreaDrawer.grid && gridAreaDrawer.grid.new"

                                :type="gridAreaDrawer.action"
                                :rows="gridAreaDrawer.grid.new.rows"
                                :columns="gridAreaDrawer.grid.new.columns"
                                :active-breakpoint="gridAreaDrawer.form.breakpoint"
                                :areas="gridAreaDrawer.grid.new.gridAreas"

                                @update:position="updateGridAreaDrawerPosition"
                            )
                        template(v-else)
                            grid-preview(
                                v-if="gridAreaDrawer.grid && gridAreaDrawer.grid.new"

                                :type="gridAreaDrawer.action"
                                :rows="gridAreaDrawer.grid.new.rows"
                                :columns="gridAreaDrawer.grid.new.columns"
                                :active-breakpoint="gridAreaDrawer.form.breakpoint"
                                :active-area="gridAreaDrawer.form.area"
                                :areas="[gridAreaDrawer.form.area, ...gridAreaDrawer.grid.new.gridAreas]"

                                @update:position="updateGridAreaDrawerPosition"
                            )
                    .alert.primary.mb-6(v-if="!gridAreaDrawer.form.position")
                        p {{ $t('Choose a position where the grid area should be created') }}

                .position(v-else)
                    grid-preview(
                        v-if="gridAreaDrawer.grid"

                        :type="gridAreaDrawer.action"
                        :rows="gridAreaDrawer.grid.rows"
                        :columns="gridAreaDrawer.grid.columns"
                        :active-breakpoint="gridAreaDrawer.form.breakpoint"
                        :active-area="gridAreaDrawer.form.area"
                        :areas="[gridAreaDrawer.form.area, ...gridAreaDrawer.grid.gridAreas.filter(el => el.id !== gridAreaDrawer.form.area.id)]"
                    )

                .rest-of-the-form.mt-8(v-if="gridAreaDrawer.action === 'edit' || gridAreaDrawer.form.position")
                    el-form-item(:label="$t('Name')" prop="name")
                        el-input(
                            v-model="gridAreaDrawer.form.area.name"
                            autocomplete="off"
                            v-focus
                            maxlength="255"
                            show-word-limit
                            :placeholder="$t('Area')"
                        )
                    el-form-item(v-if="gridAreaDrawer.action === 'create'" :label="$t('Size')" prop="size")
                        el-input(
                            v-model="gridAreaDrawer.form.size"
                            autocomplete="off"
                            maxlength="255"
                            show-word-limit
                            :placeholder="$t('1fr / 300px / 20vw ...')"
                        )
                    .flex-row(v-else)
                        el-form-item.grow(
                            v-for="(column, i) in gridAreaDrawer.form.columns" :key="column.i"
                            :label="$t('Size')"
                            :prop="`columns.${i}.value`"
                        )
                            el-input(
                                v-model="gridAreaDrawer.form.columns[i].value"
                                autocomplete="off"
                                maxlength="255"
                                show-word-limit
                                :placeholder="$t('1fr / 300px / 20vw ...')"
                            )

                    //- .flex-row
                    //-     el-form-item(
                    //-         v-if="gridAreaDrawer.action === 'create'"
                    //-         :label="$t('Position')"
                    //-         prop="position"
                    //-     )
                    //-         el-radio-group(v-model="gridAreaDrawer.form.position")
                    //-             el-radio-button(key="left" value="left" label="left") {{ $t('Left') }}
                    //-             el-radio-button(key="right" value="right" label="right") {{ $t('Right') }}
                    //-     el-form-item.grow(:label="$t('Size')" prop="size")
                    //-         el-input(
                    //-             v-model="gridAreaDrawer.form.size"
                    //-             autocomplete="off"
                    //-             maxlength="255"
                    //-             show-word-limit
                    //-             :placeholder="$t('1fr / 300px / 20vw ...')"
                    //-         )
        .drawer-footer
            .left
                el-button(
                    round
                    size="mini"
                    icon="el-icon-fa-times fas"
                    @click="gridAreaDrawer.visibility = false"
                ) {{ $t('Dismiss') }}
            .right
                el-button(
                    v-if="saveable"
                    round
                    size="mini"
                    :disabled="gridAreaDrawer.loading"
                    :loading="gridAreaDrawer.saving"
                    type="primary"
                    icon="el-icon-fa-check fas"
                    @click="saveAreaSettings"
                ) {{ $t('Save and close') }}
                el-button(
                    v-else
                    round
                    size="mini"
                    :disabled="gridAreaDrawer.loading"
                    :loading="gridAreaDrawer.saving"
                    type="primary"
                    icon="el-icon-fa-check fas"
                    @click="applyAreaSettings"
                ) {{ $t('Ok') }}

    el-dialog.delete-section-dialog(
        :title="deleteDialog.title"
        :visible.sync="deleteDialog.visibility"
        :close-on-click-modal="false"
        :append-to-body="true"
        top="10vh"
        width="460px"
        @closed="resetDeleteDialog"
    )
        .body(v-loading="deleteDialog.loading")
            template(v-if="deleteDialog.type === 'grid'")
                p.mb-2 {{ $t('Do you really want to delete this grid?') }}
                p {{ $t('Included sections will also be deleted!') }}
            p(v-else-if="deleteDialog.type === 'area'") {{ $t('Do you really want to delete this area?') }}
            p(v-else) {{ $t('Do you really want to delete this section?') }}
        template(slot="footer")
            .modal-footer
                .left
                    el-checkbox(v-model="deleteDialog.remember") {{ $t("Don't keep asking") }}
                .right
                    el-button(
                        size="mini"
                        icon="el-icon-fa-times fas"
                        :disabled="deleteDialog.loading"
                        @click="closeDeleteDialog"
                    ) {{ $t('Cancel') }}
                    el-button(
                        size="mini"
                        type="danger"
                        icon="el-icon-fa-trash-alt fas"
                        :disabled="deleteDialog.loading"
                        @click="() => deleteElement(deleteDialog.type)"
                    ) {{ $t('Delete') }}
</template>

<i18n>
{
    "de": {
        "Area": "Rasterelement",
        "Area is not supported!": "Dieser Rasterelement wird nicht unterstützt!",
        "Area is disabled!": "Dieser Rasterelement ist deaktiviert!",
        "Add area": "Rasterelement hinzufügen",
        "Edit area": "Rasterelement bearbeiten",
        "Create area": "Rasterelement erstellen",
        "Choose a position where the grid area should be created": "Wählen Sie eine Position aus, an der das Rasterelement erstellt werden soll",

        "Edit grid": "Raster bearbeiten",
        "Grid settings": "Raster Einstellungen",

        "Position": "Position",
        "Left": "Links",
        "Right": "Rechts",
        "Size": "Größe",

        "Content element is not supported!": "Dieses Inhaltselement wird nicht unterstützt!",
        "Content element is disabled!": "Dieses Inhaltselement ist deaktiviert!",
        "Content element is not activated!": "Dieses Inhaltselement ist nicht aktiviert!",
        "Grid": "Raster",
        "Grid could not be created.": "Grid konnte nicht erstellt werden.",
        "Delete section": "Inhaltselement löschen",
        "Delete grid": "Raster löschen",
        "Grid could not be saved.": "Raster konnte nicht gespeichert werden.",
        "Section could not be saved.": "Inhaltselement konnte nicht gespeichert werden.",
        "Section has been deleted successfully": "Inhaltselement wurde erfolgreich gelöscht",
        "Section could not be deleted!": "Inhaltselement konnte nicht gelöscht werden!",
        "Do you really want to delete this section?": "Soll dieses Inhaltselement wirklich gelöscht werden?",
        "Do you really want to delete this grid?": "Soll dieses Raster wirklich gelöscht werden?",
        "Do you really want to delete this area?": "Soll dieses Rasterelement wirklich gelöscht werden?",
        "Included sections will also be deleted!": "Enthaltene Inhaltselemente werden ebenfalls gelöscht!",
        "Add content element": "Inhaltselement hinzufügen",
        "Delete area": "Rasterelement löschen",
        "Delete entire grid": "Gesamtes Raster löschen",
        "Sections": "Inhaltselemente",
        "Grids": "Raster"
    }
}
</i18n>


<script>

import _ from 'lodash'
import uniqid from 'uniqid'
import draggable from 'vuedraggable'

import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css'

import { getActiveBreakpoint, getActiveGridConfig, checkRestrictions } from '@/helpers'
import { sectionIsVisible } from '@/utils/sectionVisibility'

import { useSetupStore, usePageStore, useAuthStore } from '@/stores'

import Grid from '@/components/Page/Grid'
import GridPreview from '@/components/Page/Grid/Preview'
import CategoryPosts from '@/components/Page/Sections/CategoryPosts'
import Events from '@/components/Page/Sections/Events'
import Files from '@/components/Page/Sections/Files'
import Pages from '@/components/Page/Sections/Pages'
import Form from '@/components/Page/Sections/Form'
import FormV2 from '@/components/Page/Sections/FormV2'
import Menu from '@/components/Page/Sections/Menu'
import Evaluation from '@/components/Page/Sections/Extensions/Evaluation'
import Section from '@/components/Page/Sections/Section'
import discardGuard from '@/mixins/discardGuard'

import CategoryProducts from '@/extensions/shop/components/Sections/CategoryProducts'
import BudgetPlanning from '@/extensions/shop/components/Sections/BudgetPlanning'
import Products from '@/extensions/shop/components/Sections/Products'
import Articles from '@/extensions/shop/components/Sections/Articles'
import MapBox from '@/extensions/maps/components/Sections/MapBox'
import AddSectionDialog from '@/components/Page/AddSectionDialog'

import SectionApi from '@/store/api/cms/section';

export default {
    name: 'Area',
    mixins: [discardGuard],
    props: {
        // module: {
        //     type: String,
        //     required: true
        // },
        // page: {
        //     type: Object,
        //     required: true
        // },
        config: {
            type: Object,
            required: true
        },
        rootAreaConfig: {
            type: Object,
            required: false,
        },
        hide: {
            type: [Array, Boolean],
            default: false
        },
        sectionsAddress: {
            type: Array,
            required: true,
        },
        areaSectionOptions: {
            type: Array,
            required: true,
        },
        areaGridOptions: {
            type: Array,
            required: true,
        },
        activeGridConfig: {
            type: Object,
            required: false,
        },
        gridSection: {
            type: Object,
            required: false,
            default: null,
        },
        sortable: {
            type: Boolean,
            default: false
        },
        deletable: {
            type: Boolean,
            default: true
        },
        dragging: {
            type: Boolean,
            default: false
        },
        triggerUpdateGridPositions: {
            type: Boolean,
            default: false,
        },
        nth: {
            type: Number
        },
    },
    data() {
        return {
            // error: false,
            // notFound: false,
            // pathNotValid: false,
            // loading: false,
            // dragging: false,

            editSection: undefined,
            savingSection: undefined,
            pendingSection: undefined,
            updateGridPositions: false,
            addSectionDialogVisible: false,
            draggingNewSection: null,
            dragOverPosition: null,

            areaStyles: undefined,

            tippy: [
                {
                    instance: undefined,
                    trigger: 'click focus',
                    placement: 'bottom',
                    button: 'header:area-settings-button',
                    list: 'header:area-settings',
                }
            ],

            deleteDialog: {
                title: undefined,
                visibility: false,
                loading: false,
                remember: false,
                data: undefined,
                type: 'section',
            },
            gridAreaDrawer: {
                title: undefined,
                action: 'create', // 'create' | 'edit'
                visibility: false,
                loading: false,
                saving: false,
                grid: undefined,
                // target: undefined,
                form: undefined,
                formSnapshot: undefined,
                rules: undefined,
            },

            gridRowPosition: {
                valid: false,
                label: undefined,
                start: undefined,
                end: undefined,
                rows: [],
            },
            gridColumnPosition: {
                valid: false,
                label: undefined,
                start: undefined,
                end: undefined,
                columns: [],
            }
        }
    },
    components: {
        Grid,
        GridPreview,
        CategoryPosts,
        Events,
        Files,
        Pages,
        Form,
        FormV2,
        Menu,
        Section,
        Evaluation,
        draggable,
        CategoryProducts,
        BudgetPlanning,
        Products,
        Articles,
        MapBox,
        AddSectionDialog,
    },
    watch: {
        dragging(value) {
            this.$emit('dragging', value)

            if (value) {
                this.tippy.forEach(el => {
                    if (el.instance) el.instance.hide()
                })
            }
        },
        triggerUpdateGridPositions(value) {
            if (value) this.recalculateGridPositions()
        },
        'gridAreaDrawer.form.size'(value) {
            this.debouncedUpdateGridAreaDrawerRowsAndColumns()
        },
        'gridAreaDrawer.form.columns': {
            handler(value) {
                this.debouncedUpdateGridAreaDrawerRowsAndColumns()
            },
            deep: true,
        },
        // 'gridAreaDrawer.form.position'() {
        //     this.gridAreaDrawer.form.area.row = []
        //     this.gridAreaDrawer.form.area.column = []
        //     this.debouncedUpdateGridAreaDrawerRowsAndColumns()
        // },
        // 'gridAreaDrawer.form.breakpoint'() {
        //     this.debouncedUpdateGridAreaDrawerRowsAndColumns()
        // }
    },
    computed: {
        pageStore() {
            return usePageStore()
        },
        form() {
            return this.pageStore.form
        },
        saveable() {
            if (this.pageStore.isGlobalContentsMode) return true
            let saveable = true
            if (!this.form.id || _.startsWith(this.form.id, 'new:')) {
                saveable = false
            }
            return saveable
        },
        breakpoints() {
            return _.get(this.activeCms, 'config.template.breakpoints') || []
        },
        configurable() {
            let configurable = false
            if (this.activeGridConfig && this.activeGridConfig.type === 'dynamic') configurable = true
            return configurable
        },
        activeAreaConfig() {
            let config = {
                row: [],
                column: [],
            }

            // get current breakpoint (manually selectable)
            // get corresponding style config
            if (this.breakpoints.length && this.activeBreakpoint) {
                const indexes = _.cloneDeep(this.breakpoints).sort((a, b) => a.value - b.value).map((el, i) => el.key)
                config.row = getActiveGridConfig(indexes, this.config.row, this.activeBreakpoint.key)
                config.column = getActiveGridConfig(indexes, this.config.column, this.activeBreakpoint.key)
            }

            return config
        },
        style() {
            let titleTop = 0
            if (this.nestingLevel > 1) {
                titleTop = 41
                if (this.nestingLevel > 2) {
                    titleTop += (this.nestingLevel - 2) * 40
                }
            }

            let row
            if (this.activeAreaConfig.row && _.isArray(this.activeAreaConfig.row)) {
                row = this.activeAreaConfig.row.join(' ')
            } else {
                row = this.activeAreaConfig.row
            }

            let column
            if (this.activeAreaConfig.column && _.isArray(this.activeAreaConfig.column)) {
                column = this.activeAreaConfig.column.join(' ')
            } else {
                column = this.activeAreaConfig.column
            }

            return {
                'grid-row': row,
                'grid-column': column,
                '--nesting-level': this.nestingLevel,
                '--title-top': `${titleTop}px`,
            }
        },
        key() {
            // return _.get(this.config, 'key') || 'main'
            if (this.sectionsAddress) {
                const address = _.cloneDeep(this.sectionsAddress)
                return address.shift()
            } else {
                return _.get(this.config, 'key') || 'main'
            }
        },
        name() {
            const name = _.get(this.config, 'name', '')
            return this.$t(name)
        },
        path() {
            let path = 'sections'
            if (this.sectionsAddress && this.sectionsAddress.length > 1) {
                const address = _.cloneDeep(this.sectionsAddress)
                address.shift()
                path = address.join('.')
            }
            return path
        },
        options() {
            return this.pageStore.options
        },
        sections: {
            get() {
                let sections = _.get(this.form, this.path) || []
                if (!this.pageStore.isGlobalContentsMode) {
                    sections = _.cloneDeep(sections.filter(section => section.area === this.key))
                } else {
                    sections = _.cloneDeep(sections)
                }

                // remove teaser section from category page module
                const teaser = _.get(this.activeCms, 'config.template.teaser')
                if (teaser && teaser.key) sections = sections.filter(section => section.key !== teaser.key)

                sections = sections.sort((a, b) => _.get(a, 'position', 0) - _.get(b, 'position', 0))
                return sections
            },
            set(sections) {
                if (sections.length === this.sections.length) {
                    // add sectionsAddress
                    this.pageStore.sortSections({ path: this.path, sections })
                    this.saveSectionPositions()
                    // console.log('>>>>>>>>>>>>>>>>>> set sections', sections, this.sectionsAddress)
                } else {

                    // get index of the one section without id
                    const s = _.findIndex(sections, section => section.id === undefined)
                    // console.log('>>>>>>>>>>>>>>>>>> set sections', s, sections, this.sectionsAddress)

                    if (s >= 0) {
                        // create
                        let section = _.cloneDeep(sections[s])
                        this.addSection(undefined, s, section)
                    } else {
                        // nested move

                        this.pageStore.reorganizeSections({
                            s, level: this.nestingLevel,
                            area: this.key,
                            path: this.path,
                            sections,
                        })

                        this.saveSectionPositions()
                    }
                }
            }
        },
        sectionOptions() {
            const sections = _.get(this.config, 'sections') || []

            let options = []
            sections.forEach(section => {
                const config = _.get(this.activeCms, 'config.template.sections', [])
                    .find(item => item.key === section.key)

                if (!config) return;

                // check for supported extensions
                // hide button if not supported
                const supported = this.sectionIsSupported(section.key, config)
                if (! supported) return

                let option = { is: 'section', ...section, ...config}

                // check for enabled extensions
                // disable button if not supported
                const disabled = this.sectionIsDisabled(section.key, config)
                if (disabled) option.disabled = true

                // check for user permissions
                const notPermitted = this.sectionIsNotPermitted(section.key)
                if (notPermitted) {
                    option.disabled = true
                    option.notPermitted = true
                }

                // check if section should be hidden
                // based on custom flag and settings
                const visible = this.sectionIsVisible(section.key)
                if (!visible) return

                options.push(option)
            })

            if (! options.length) options = this.areaSectionOptions
            return options
        },
        gridOptions() {
            const grids = _.get(this.config, 'grids') || []

            let options = []
            grids.forEach(grid => {
                const config = _.get(this.activeCms, 'config.template.grids', [])
                    .find(item => item.key === grid.key)

                if (config) {
                    const option = { is: 'grid', ...grid, ...config}
                    // TODO: initialize grid
                    options.push(option)
                }
            })

            if (! options.length) options = this.areaGridOptions
            return options
        },
        areaIsSupported() {
            const supportedExtensions = _.get(this.activeCms, 'config.template.extensions') || []

            const extension = _.get(this.config, 'extension.key')
            if (extension) return supportedExtensions.includes(extension)
            else return true
        },
        areaIsDisabled() {
            const extension = _.get(this.config, 'extension.key')
            if (extension) return ! this.enabledExtensions.includes(extension)
            return false
        },
        nestingLevel() {
            // 2 entries are set on root (components/Page/Main.vue)
            // 1 entry is set here for the current section index (Grid: :sections-address="[...sectionsAddress, getSectionIndex(section)]")
            // 3 entries are set in every Grid component (components/Page/Grid)
            return (this.sectionsAddress.length - 2 + 4) / 4
        },
        activeCms() {
            return useSetupStore().activeCms;
        },
        settingValues() {
            return useSetupStore().settingValues;
        },
        enabledExtensions() {
            return useSetupStore().enabledExtensions;
        },
        activeBreakpoint() {
            return useSetupStore().activeBreakpoint;
        },
        isSuperUser() {
            return useAuthStore().isSuperUser;
        },
        copiedSection() {
            var cmsId = _.get(this.activeCms, 'id');
            if (!cmsId) return null;
            return _.get(useSetupStore().clipboard, 'cms:' + cmsId + '.section');
        },
        isGridCopied() {
            return this.gridSection && this.copiedSection && this.copiedSection.sectionId === this.gridSection.id;
        },
        canPasteHere() {
            if (!this.copiedSection) return false;
            var copiedKey = this.copiedSection.sectionKey;
            var copiedType = this.copiedSection.sectionType;
            if (copiedType === 'grid') {
                return this.gridOptions.some(function (option) { return option.key === copiedKey; });
            }
            return this.sectionOptions.some(function (option) { return option.key === copiedKey; });
        },
    },
    methods: {
        sectionIsVisible(key) {
            const section = _.get(this.activeCms, 'config.template.sections', []).find(item => item.key === key)
            // // Custom sections are visible only to super-users
            // if (section.custom === true) {
            //     return this.isSuperUser
            // }

            return sectionIsVisible(section, this.settingValues)
        },
        copyGridSection() {
            var setupStore = useSetupStore();
            if (this.isGridCopied) {
                setupStore.removeFromClipboard('section');
            } else {
                var gridConfig = _.get(this.activeCms, 'config.template.grids', [])
                    .find(function (item) { return item.key === this.gridSection.key; }.bind(this));
                setupStore.setClipboard({
                    key: 'section',
                    value: {
                        sectionId: this.gridSection.id,
                        sectionKey: this.gridSection.key,
                        sectionType: this.gridSection.type,
                        sectionName: (gridConfig && gridConfig.name) || this.gridSection.key,
                    },
                });
            }
        },
        cancelPaste() {
            this.pendingSection = undefined;
            useSetupStore().removeFromClipboard('section');
        },
        handleEscapeKey(event) {
            // Esc cancels the "choose where to add" mode, mirroring the X button.
            if (event.key !== 'Escape') return
            if (this.pendingSection || (this.copiedSection && this.canPasteHere)) {
                event.preventDefault()
                this.cancelPaste()
            }
        },
        pasteSection(event, position) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }

            if (!this.copiedSection) return;

            var gridAreaId = null;
            if (this.path !== 'sections') {
                var address = this.path.split('.');
                if (address.length > 1) {
                    address.pop();
                    var gridAreaPath = address.join('.');
                    var gridArea = _.get(this.form, gridAreaPath);
                    if (gridArea) {
                        gridAreaId = gridArea.id;
                    }
                }
            }

            this.pageStore.pasteSection({
                path: this.path,
                sectionId: this.copiedSection.sectionId,
                pageId: this.form.id,
                position: position,
                gridAreaId: gridAreaId,
                area: this.key,
            })
                .then(function () {
                    useSetupStore().removeFromClipboard('section');
                })
                .catch(function (error) {
                    console.error(error);
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Section could not be saved.'),
                        iconClass: 'fas el-icon-fa-xmark',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    });
                }.bind(this));
        },
        setPendingSection(event, section) {
            this.tippy.forEach(el => {
                if (el.instance) el.instance.hide()
            })

            if (this.sections && this.sections.length) {
                this.pendingSection === section ? this.pendingSection = undefined : this.pendingSection = section
            } else {
                this.addSection(event, 0, section)
            }
        },
        openGridAreaDrawer({ area, grid, gridColumnPosition, gridRowPosition }, action) {
            this.gridAreaDrawer.visibility = true

            let index
            const indexes = _.cloneDeep(this.breakpoints).sort((a, b) => a.value - b.value).map(el => el.key)
            const columnBreakpoint = getActiveBreakpoint(indexes, grid.columns, this.activeBreakpoint.key)
            if (columnBreakpoint) index = indexes.indexOf(columnBreakpoint)
            const rowBreakpoint = getActiveBreakpoint(indexes, grid.rows, this.activeBreakpoint.key)
            if (rowBreakpoint) index = Math.max(indexes.indexOf(rowBreakpoint), index)

            let activeBreakpoint = this.activeBreakpoint
            if (index >= 0) {
                const key = indexes[index]
                activeBreakpoint = this.breakpoints.find(el => el.key === key)
            }

            if (action === 'create') {
                this.gridAreaDrawer.grid = { old: _.cloneDeep(grid), new: _.cloneDeep(grid) }

                this.gridAreaDrawer.title = this.$t('Create area')
                this.gridAreaDrawer.action = 'create'

                // this.gridAreaDrawer.target = { area, gridRowPosition, gridColumnPosition }

                this.gridAreaDrawer.form = {
                    breakpoint: activeBreakpoint,
                    // position: 'right',
                    position: undefined,
                    size: '1fr',
                    area: {
                        id: uniqid('new:'),
                        key: uniqid('#'),
                        name: '',
                        row: [],
                        column: [],
                    }
                }

                this.gridAreaDrawer.rules = {
                    position: 'required',
                    size: 'required',
                }

            } else {
                this.gridAreaDrawer.grid = _.cloneDeep(grid)

                this.gridAreaDrawer.title = this.$t('Edit area')
                this.gridAreaDrawer.action = 'edit'

                const activeGridConfig = {
                    columns: getActiveGridConfig(indexes, this.gridAreaDrawer.grid.columns, activeBreakpoint.key),
                    rows: getActiveGridConfig(indexes, this.gridAreaDrawer.grid.rows, activeBreakpoint.key),
                }

                let columns = []
                for (let i = gridColumnPosition.start; i < gridColumnPosition.end; i++) {
                    const value = _.get(activeGridConfig.columns, i - 1)
                    if (value) columns.push({ i, value })
                    else throw new Error('Column not found')
                }

                if (!columns.length) {
                    throw new Error('Column missing')
                } else {
                    this.gridAreaDrawer.form = {
                        breakpoint: activeBreakpoint,
                        columns,
                        area
                    }

                    this.gridAreaDrawer.rules = {
                        columns: columns.map(() => ({
                            i: 'required',
                            value: 'required',
                        })),
                    }
                }
            }

            this.gridAreaDrawer.formSnapshot = this.snapshotOf(this.gridAreaDrawer.form)
        },
        updateGridAreaDrawerPosition(position) {
            this.$set(this.gridAreaDrawer.form, 'position', position)
            if (this.gridAreaDrawer.action === 'create') {
                // this.gridAreaDrawer.form.area.row = []
                // this.gridAreaDrawer.form.area.column = []
                this.gridAreaDrawer.grid.new = _.cloneDeep(this.gridAreaDrawer.grid.old)
            }
            this.updateGridAreaDrawerRowsAndColumns()
        },
        debouncedUpdateGridAreaDrawerRowsAndColumns: _.debounce(function() {
            this.updateGridAreaDrawerRowsAndColumns()
        }, 100),
        updateGridAreaDrawerRowsAndColumns() {
            // get current breakpoint (manually selectable)
            // get corresponding style config
            const breakpoint = _.get(this.gridAreaDrawer, 'form.breakpoint.key')
            if (this.breakpoints.length && breakpoint) {
                const indexes = _.cloneDeep(this.breakpoints).sort((a, b) => a.value - b.value).map(el => el.key)

                if (this.gridAreaDrawer.action === 'edit') {
                    const config = {
                        rows: getActiveGridConfig(indexes, this.gridAreaDrawer.grid.rows, breakpoint),
                        columns: getActiveGridConfig(indexes, this.gridAreaDrawer.grid.columns, breakpoint)
                    }

                    if (config.columns) {
                        const columnsOptions = config.columns.map(value => ({ key: value, value }))

                        this.gridAreaDrawer.form.columns.forEach(column => {
                            columnsOptions.splice(column.i - 1, 1, { key: column.value, value: column.value })
                        })

                        const columnsValue = columnsOptions.map(el => el.value).join(' ')
                        const i = this.gridAreaDrawer.grid.columns.findIndex(el => el.key === breakpoint)
                        if (i >= 0) {
                            this.gridAreaDrawer.grid.columns[i].options = columnsOptions
                            this.gridAreaDrawer.grid.columns[i].value = columnsValue
                        } else {
                            this.gridAreaDrawer.grid.columns.push({
                                key: breakpoint,
                                options: columnsOptions,
                                value: columnsValue,
                            })
                        }
                    }

                } else if (this.gridAreaDrawer.action === 'create' && _.get(this.gridAreaDrawer, 'form.position')) {
                    const config = {
                        rows: getActiveGridConfig(indexes, this.gridAreaDrawer.grid.old.rows, breakpoint),
                        columns: getActiveGridConfig(indexes, this.gridAreaDrawer.grid.old.columns, breakpoint)
                    }

                    if (config.rows) {
                        // const rowsOptions = config.rows.map(value => ({ key: value, value }))
                        // const newRowOption = { key: this.gridAreaDrawer.form.size, value: this.gridAreaDrawer.form.size }
                        // const rowPosition = this.gridAreaDrawer.target.gridRowPosition

                        let areaRow
                        const r = this.gridAreaDrawer.form.area.row.findIndex(el => el.key === breakpoint)
                        if (r >= 0) {
                            areaRow = this.gridAreaDrawer.form.area.row[r]
                            areaRow.value = this.gridAreaDrawer.form.position.row
                        } else {
                            areaRow = { key: breakpoint, value: this.gridAreaDrawer.form.position.row }
                            this.gridAreaDrawer.form.area.row.push(areaRow)
                        }
                    }

                    if (config.columns) {
                        const size = this.gridAreaDrawer.form.size || '1fr'
                        const columnsOptions = config.columns.map(value => ({ key: value, value }))
                        const newColumnOption = { key: size, value: size }
                        // const columnPosition = this.gridAreaDrawer.target.gridColumnPosition

                        let areaColumn
                        const c = this.gridAreaDrawer.form.area.column.findIndex(el => el.key === breakpoint)
                        if (c >= 0) {
                            areaColumn = this.gridAreaDrawer.form.area.column[c]
                        } else {
                            areaColumn = { key: breakpoint, value: this.gridAreaDrawer.form.position.column }
                            this.gridAreaDrawer.form.area.column.push(areaColumn)
                        }

                        columnsOptions.splice(this.gridAreaDrawer.form.position.column - 1, 0, newColumnOption)
                        areaColumn.value = this.gridAreaDrawer.form.position.column

                        const columnsValue = columnsOptions.map(el => el.value).join(' ')

                        const i = this.gridAreaDrawer.grid.new.columns.findIndex(el => el.key === breakpoint)
                        if (i >= 0) {
                            this.gridAreaDrawer.grid.new.columns[i].options = columnsOptions
                            this.gridAreaDrawer.grid.new.columns[i].value = columnsValue
                        } else {
                            this.gridAreaDrawer.grid.new.columns.push({
                                key: breakpoint,
                                options: columnsOptions,
                                value: columnsValue,
                            })
                        }
                    }


                    // reorganize existing grid areas
                    // move out of the way

                    const getActualPosition = (gridNode, config) => {
                        const areaNode = document.createElement('div');

                        if (config.row && _.isArray(config.row)) areaNode.style.gridRow = config.row.join(' ')
                        else areaNode.style.gridRow = config.row

                        if (config.column && _.isArray(config.column)) areaNode.style.gridColumn = config.column.join(' ')
                        else areaNode.style.gridColumn = config.column

                        gridNode.appendChild(areaNode);

                        document.body.appendChild(gridNode)
                        const areaStyles = window.getComputedStyle(areaNode)
                        const calculated = {
                            column: {
                                start: areaStyles.getPropertyValue('grid-column-start'),
                                end: areaStyles.getPropertyValue('grid-column-end'),
                            },
                            row: {
                                start: areaStyles.getPropertyValue('grid-row-start'),
                                end: areaStyles.getPropertyValue('grid-row-end'),
                            },
                        }
                        document.body.removeChild(gridNode);

                        // console.log('>>> get actual position', config, calculated)

                        const types = ['column', 'row']
                        types.forEach(type => {
                            if (calculated[type].start === 'auto' || parseInt(calculated[type].start) === NaN) {
                                calculated[type].start = 1
                            } else if (parseInt(calculated[type].start) !== NaN) {
                                calculated[type].start = parseInt(calculated[type].start)
                            }
                            if (calculated[type].end === 'auto' || parseInt(calculated[type].end) === NaN
                                || calculated[type].end <= calculated[type].start) {
                                calculated[type].end = parseInt(calculated[type].start) + 1;
                            } else if (parseInt(calculated[type].end) !== NaN) {
                                calculated[type].end = parseInt(calculated[type].end)
                            }
                        })

                        return calculated
                    }

                    // new config
                    const nc = {
                        // grid config
                        grid: {
                            rows: getActiveGridConfig(indexes, this.gridAreaDrawer.grid.new.rows, breakpoint),
                            columns: getActiveGridConfig(indexes, this.gridAreaDrawer.grid.new.columns, breakpoint),
                        },
                        // area config
                        area: {
                            row: getActiveGridConfig(indexes, this.gridAreaDrawer.form.area.row, breakpoint),
                            column: getActiveGridConfig(indexes, this.gridAreaDrawer.form.area.column, breakpoint),
                        }
                    }

                    const gridNode = document.createElement('div')
                    gridNode.style.gridTemplateRows = nc.grid.rows.join(' ')
                    gridNode.style.gridTemplateColumns = nc.grid.columns.join(' ')
                    gridNode.style.display = 'none'
                    // gridNode.classList.add('hidden');

                    const calculatedAreaPosition = getActualPosition(gridNode, nc.area)
                    // const calculatedAreaSpan = calculatedAreaPosition.column.end - calculatedAreaPosition.column.start

                    // check for collisions

                    let traversals = 0
                    let maxTraversals = 1000
                    let fixedAreas = []
                    const fixCollision = (A, area) => {
                        if (traversals > maxTraversals) return
                        traversals++

                        if (fixedAreas.includes(area.id)) return

                        // console.log('>>> fix collision', area.id, A)

                        // area config
                        let ac = {
                            row: getActiveGridConfig(indexes, area.row, breakpoint),
                            column: getActiveGridConfig(indexes, area.column, breakpoint),
                        }

                        if (ac.row === undefined || ac.column === undefined) {
                            throw new Error('invalid grid area config')
                        }

                        const B = getActualPosition(gridNode, ac)
                        // map.push(B)

                        // skip other rows
                        // console.log('>>> check for different row', area.id, ac.row, B.row, A.row)
                        if (B.row.start >= A.row.end || B.row.end <= A.row.start) {
                            // console.log('>>> skip different row', area.id)
                            return
                        }

                        // these are all possible collisions
                        //          ▒▒▒▒██░░░░
                        // area ▒B▒ starts before area ░A░ ends
                        // area ▒B▒ ends after area ░A░ starts

                        // A needs to stay, B needs to be moved

                        if (B.column.start < A.column.end && B.column.end > A.column.start) {
                            // console.log('>>> collision detected', A, _.cloneDeep(B))

                            const span = A.column.end - B.column.start

                            B.column.start += span
                            B.column.end += span

                            fixedAreas.push(area.id)

                            // console.log('>>> collision resolved', B, span)

                            // B.column.start += width
                            // B.column.end += width

                            let value = `${B.column.start} / ${B.column.end}`
                            const width = B.column.end - B.column.start
                            if (width <= 1) value = B.column.start.toString()

                            let column = { key: breakpoint, value }
                            const i = area.column.findIndex(el => el.key === breakpoint)
                            if (i >= 0) area.column[i] = column
                            else area.column.push(column)

                            this.gridAreaDrawer.grid.new.gridAreas.forEach(el => {
                                fixCollision(B, el)
                            })
                        }

                        // if starts before but ends on the same line, move right
                        // TODO

                        // setAreaOccupation(area)
                    }

                    // const setAreaOccupation = (area) => {
                    //     area.occupied = { rows: [], columns: [] }

                    //     const ac = {
                    //         row: getActiveGridConfig(indexes, area.row, breakpoint),
                    //         column: getActiveGridConfig(indexes, area.column, breakpoint),
                    //     }

                    //     const types = ['column', 'row']
                    //     types.forEach(type => {
                    //         const calculated = getActualPosition(gridNode, ac)
                    //         const start = calculated[type].start
                    //         const end = calculated[type].end

                    //         // const values = ac[type].map(value => {
                    //         //     if (parseInt(value) !== NaN) return parseInt(value)
                    //         //     return null
                    //         // }).filter(Boolean)

                    //         // const start = Math.min(...values)
                    //         // const end = Math.max(start + 1, ...values)

                    //         // console.log('>>', type, values, start, end)

                    //         for (let position = parseInt(start); position < parseInt(end); position++) {
                    //             if (!area.occupied[type + 's'].includes(position)) area.occupied[type + 's'].push(position)
                    //         }
                    //     })
                    // }

                    // this.gridAreaDrawer.grid.new.gridAreas.forEach(area => {
                    //     const ac = {
                    //         row: getActiveGridConfig(indexes, area.row, breakpoint),
                    //         column: getActiveGridConfig(indexes, area.column, breakpoint),
                    //     }

                    //     setAreaOccupation(area)
                    // })

                    // setAreaOccupation(this.gridAreaDrawer.form.area)

                    this.gridAreaDrawer.grid.new.gridAreas.forEach(area => {
                        return fixCollision(calculatedAreaPosition, area)
                    })
                }
            }
        },
        toggleAreaSettings() {
            // TODO
            // this.gridAreaDrawer.title = this.$t('Edit area')
        },
        applyAreaSettings() {
            this.$refs['grid-area-drawer-form'].validate((valid, errors) => {
                if (valid) {
                    const oldGrid = this.gridAreaDrawer.grid.old

                    const newGrid = this.gridAreaDrawer.grid.new
                    newGrid.gridAreas.push(this.gridAreaDrawer.form.area)

                    this.pageStore.replaceSection({ path: this.path, oldSection: oldGrid, newSection: newGrid })

                    this.gridAreaDrawer.visibility = false
                } else {
                    this.$notify.warning({
                        title: this.$t('Form is not valid!'),
                        message: this.$t('Correct your input and submit again.'),
                        iconClass: 'fas el-icon-fa-exclamation-circle',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                }
            })
        },
        saveAreaSettings() {
            this.$refs['grid-area-drawer-form'].validate((valid, errors) => {
                if (valid) {
                    this.gridAreaDrawer.saving = true

                    let grid
                    if (this.gridAreaDrawer.action === 'create') {
                        grid = this.gridAreaDrawer.grid.new
                        grid.gridAreas.push(this.gridAreaDrawer.form.area)
                    } else {
                        grid = this.gridAreaDrawer.grid
                        grid.gridAreas = grid.gridAreas.filter(area => area.id !== this.gridAreaDrawer.form.area.id)
                        grid.gridAreas.push(this.gridAreaDrawer.form.area)
                    }

                    this.saveGrid(grid)
                } else {
                    this.$notify.warning({
                        title: this.$t('Form is not valid!'),
                        message: this.$t('Correct your input and submit again.'),
                        iconClass: 'fas el-icon-fa-exclamation-circle',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                }
            })
        },
        saveGrid(grid) {
            let areas = _.cloneDeep(grid.gridAreas)
            areas.sort((a, b) => a.id - b.id)

            grid.gridAreas = grid.gridAreas.map((area, i) => {
                return {
                    id: area.id,
                    key: area.key,
                    name: area.name,
                    row: area.row,
                    column: area.column,
                }
            })

            this.pageStore.saveSection({
                path: this.path,
                section: grid,
            })
                .then(newSection => {
                    this.gridAreaDrawer.visibility = false

                    newSection.gridAreas.sort((a, b) => a.id - b.id)
                    newSection.gridAreas = newSection.gridAreas.map((area, i) => {
                        const gridItems = _.get(areas, `${i}.gridItems`)
                        if (gridItems) area.gridItems = gridItems
                        return area
                    })
                    this.pageStore.replaceSection({ path: this.path, oldSection: grid, newSection })

                    this.$nextTick(() => {
                        // refresh areaStyles
                        // this.recalculateGridPositions()
                        this.updateGridPositions = newSection.id
                        setTimeout(() => this.updateGridPositions = false, 100)
                    })
                })
                .catch(error => {
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Grid could not be saved.'),
                        iconClass: 'fas el-icon-fa-xmark',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });

                    // this.$nextTick(() => {
                    //     store.commit('page/sortSections', {
                    //         path: this.path,
                    //         sections: this.sections,
                    //     })
                    // })

                    console.error(error)
                })
                .finally(() => {
                    this.gridAreaDrawer.saving = false
                })
        },
        resetAreaSettingsDrawer() {
            this.gridAreaDrawer = {
                title: undefined,
                action: 'create', // 'create' | 'edit'
                visibility: false,
                loading: false,
                grid: undefined,
                // target: undefined,
                form: undefined,
                rules: undefined
            }
        },
        getSectionIndex(section) {
            const sections = _.get(this.form, this.path) || []
            return sections.findIndex(s => s.id === section.id)
        },
        debouncedSaveSectionPositions: _.debounce(function() {
            this.saveSectionPositions()
        }, 300),
        saveSectionPositions() {
            // function scope is needed here

            let sections = _.get(this.form, this.path) || []
            sections = sections.map(section => {
                return {
                    id: section.id,
                    position: section.position,
                    type: section.type,
                    area: section.area,
                }
            });

            this.pageStore.saveMultipleSections(sections)
        },
        async addSection(event, s, section) {
            if (event) {
                event.preventDefault()
                event.stopPropagation()
            }

            if (this.pendingSection) {
                this.pendingSection = undefined
                await new Promise(resolve => setTimeout(resolve, 150));
            }

            section = {
                id: uniqid('new:'),
                area: this.key,
                ...section,
            }
            // section.id = uniqid('new:')
            // section.area = this.key

            // setTimeout(() => store.commit(`${this.module}/form/addSection`, { i, s, path: this.path, section }), 300);
            this.pageStore.addSection({ s, path: this.path, section })
            // store.commit(`${this.module}/setUiAllSectionsEdit`, { i, value: false })

            if (section.is === 'grid' && this.form.id && ! _.startsWith(this.form.id, 'new:')) {
                this.$nextTick(() => {
                    const grid = this.sections.find(el => el.id === section.id)
                    // create section and update all section positions
                    this.pageStore.createSection({
                        path: this.path,
                        section: grid,
                    })
                        .then(() => {
                            const sections = this.sections.map(section => {
                                return {
                                    id: section.id,
                                    position: section.position,
                                    type: section.type,
                                    area: section.area,
                                }
                            });
                            this.pageStore.saveMultipleSections(sections)
                        })
                        .catch(error => {
                            console.error(error)

                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('Grid could not be created.'),
                                iconClass: 'fas el-icon-fa-xmark',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });

                            this.$nextTick(() => {
                                this.pageStore.sortSections({
                                    path: this.path,
                                    sections: this.sections,
                                })
                            })
                        })
                })
            } else {
                this.editSection = section
                // this.$nextTick(() => this.editSection = undefined)
            }
        },
        getSectionComponent(key) {
            switch (key) {
                case 'categoryposts':
                    return 'CategoryPosts'
                case 'events':
                    return 'Events'
                case 'files':
                    return 'Files'
                case 'pages':
                case 'posts':
                    return 'Pages'
                case 'form':
                    return 'Form'
                case 'form-v2':
                    return 'FormV2'
                case 'menu':
                    return 'Menu'
                case 'evaluation':
                    return 'Evaluation'
                case 'categoryproducts':
                    return 'CategoryProducts'
                case 'budget-planning':
                    return 'BudgetPlanning'
                case 'products':
                    return 'Products'
                case 'articles':
                    return 'Articles'
                case 'mapbox':
                    return 'MapBox'
                default:
                    return 'Section'
            }
        },
        getSectionConfig(key) {
            const sections = _.get(this.config, 'sections') || _.get(this.rootAreaConfig, 'sections') || []
            return sections.find(section => section.key === key) || {}
        },
        getGridConfig(key) {
            // const grids = _.get(this.config, 'grids') || []
            return this.gridOptions.find(grid => grid.key === key) || {}
        },
        // isUnsupported(key) {
        //     return ! this.sectionOptions.find(section => section.key === key)
        // },
        gridIsSupported(key, config = null) {
            if (! config) config = _.get(this.activeCms, 'config.template.grids', []).find(item => item.key === key)
            if (! config) return false

            let gridConfigOptions = _.get(this.config, 'grids') || []
            if (! gridConfigOptions.length) gridConfigOptions = this.areaGridOptions

            const gridConfig = gridConfigOptions.find(item => item.key === key)
            if (! gridConfig) return false

            const supportedExtensions = _.get(this.activeCms, 'config.template.extensions') || []
            const extension = _.get(config, 'extension.key')
            if (extension) return supportedExtensions.includes(extension)
            return true
        },
        sectionIsSupported(key, config = null) {
            if (! config) config = _.get(this.activeCms, 'config.template.sections', []).find(item => item.key === key)
            if (! config) return false

            let sectionConfigOptions = _.get(this.config, 'sections') || []
            if (! sectionConfigOptions.length) sectionConfigOptions = this.areaSectionOptions

            const sectionConfig = sectionConfigOptions.find(item => item.key === key)
            if (! sectionConfig) return false

            const supportedExtensions = _.get(this.activeCms, 'config.template.extensions') || []

            switch (key) {
                case 'products':
                case 'categoryproducts':
                case 'articles':
                    return supportedExtensions.includes('shop')

                case 'form':
                case 'form-v2':
                    return supportedExtensions.includes('forms')

                case 'mapbox':
                    return supportedExtensions.includes('maps')

                case 'events':
                    return supportedExtensions.includes('event-manager')

                default:
                    const extension = _.get(config, 'extension.key')
                    if (extension) return supportedExtensions.includes(extension)
                    return true
            }
        },
        sectionIsDisabled(key, config = null) {
            if (! config) config = _.get(this.activeCms, 'config.template.sections', []).find(item => item.key === key)
            if (! config) return true

            switch (key) {
                case 'products':
                case 'categoryproducts':
                case 'articles':
                    return ! this.enabledExtensions.includes('shop')

                case 'form':
                case 'form-v2':
                    return ! this.enabledExtensions.includes('forms')

                case 'mapbox':
                    return ! this.enabledExtensions.includes('maps')

                case 'events':
                    return ! this.enabledExtensions.includes('event-manager')

                default:
                    const extension = _.get(config, 'extension.key')
                    if (extension) return ! this.enabledExtensions.includes(extension)
                    return false
            }
        },
        sectionIsNotPermitted(key) {
            switch (key) {
                case 'products':
                case 'categoryproducts':
                case 'articles':
                    return !checkRestrictions('ex:shop')

                case 'form':
                case 'form-v2':
                    return !checkRestrictions('ex:frms')

                case 'events':
                    return !checkRestrictions('ex:evnt')

                default:
                    return false
            }
        },
        dropped(event) {
            // console.log('>>>>>>>>>>>>>>> dropped', event)
        },
        getGridSvg(key) {
            const SVGS = {
                1: `<svg width="20" height="14" viewBox="0 0 24 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><rect x="1" y="1" width="22" height="14" rx="2"/></svg>`,
                2: `<svg width="20" height="14" viewBox="0 0 24 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><rect x="1" y="1" width="10" height="14" rx="2"/><rect x="13" y="1" width="10" height="14" rx="2"/></svg>`,
                3: `<svg width="20" height="14" viewBox="0 0 24 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><rect x="1" y="1" width="6" height="14" rx="2"/><rect x="9" y="1" width="6" height="14" rx="2"/><rect x="17" y="1" width="6" height="14" rx="2"/></svg>`,
                4: `<svg width="20" height="14" viewBox="0 0 24 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><rect x="1" y="1" width="4" height="14" rx="2"/><rect x="7" y="1" width="4" height="14" rx="2"/><rect x="13" y="1" width="4" height="14" rx="2"/><rect x="19" y="1" width="4" height="14" rx="2"/></svg>`,
            }
            const str = String(key || '')
            const colPart = str.includes(':') ? str.split(':')[1] : str
            const cols = colPart ? colPart.split('-').length : 1
            return SVGS[cols] || SVGS[1]
        },
        checkMove(event) {
            // TODO: handle ESC key
            // if (event.originalEvent.dataTransfer.items.length === 0) {
            //     return
            // }

            const el = _.get(event.draggedContext, 'element.is')
                || _.get(event.draggedContext, 'element.type')
                || 'section'

            const allowedSections = _.get(event.to.dataset, 'allowedSections', '')
                // .split(',')

            const allowedGrids = _.get(event.to.dataset, 'allowedGrids', '')
                // .split(',')

            const allowed = {
                sections: JSON.parse(allowedSections),
                grids: JSON.parse(allowedGrids),
            }

            // console.log('>> move', el, event.draggedContext, allowed)

            switch (el) {
                case 'section':
                case 'content': // freshly created section
                    return allowed.sections.includes(event.draggedContext.element.key)
                case 'grid':
                    return allowed.grids.includes(event.draggedContext.element.key)
                default:
                    return false
            }
        },
        onDropZoneLeave(event, key) {
            if (event.relatedTarget && event.currentTarget.contains(event.relatedTarget)) return
            if (this.dragOverPosition === key) this.dragOverPosition = null
        },
        onNewSectionDragStart(section) {
            this.draggingNewSection = section
            this.addSectionDialogVisible = false
            this._onDragEnd = () => {
                this.draggingNewSection = null
                this.dragOverPosition = null
                window.removeEventListener('dragend', this._onDragEnd)
            }
            window.addEventListener('dragend', this._onDragEnd)
        },
        dropNewSection(position) {
            if (!this.draggingNewSection) return
            const section = this.draggingNewSection
            this.draggingNewSection = null
            this.dragOverPosition = null
            if (this._onDragEnd) {
                window.removeEventListener('dragend', this._onDragEnd)
                this._onDragEnd = null
            }
            this.addSection(null, position, section)
        },
        startDragging() {
            this.$emit('dragging', true)
            this.tippy.forEach(el => {
                // console.log('>> tippy', el)
                if (el.instance) el.instance.hide()
            })
        },
        endDragging() {
            this.$emit('dragging', false)
        },
        restoreMissingMediaFileData(sentSection, receivedSection) {
            if (!receivedSection || !sentSection) return receivedSection

            const sentContents = _.get(sentSection, 'contents') || []
            const receivedContents = _.get(receivedSection, 'contents') || []

            if (!receivedContents.length || !sentContents.length) return receivedSection

            const keyMatchCount = {}

            receivedContents.forEach(receivedContent => {
                const receivedMedia = _.get(receivedContent, 'media') || []
                if (!receivedMedia.length) return

                const key = receivedContent.key
                if (keyMatchCount[key] === undefined) keyMatchCount[key] = 0

                const sentContentsWithKey = sentContents.filter(c => c.key === key)
                const sentContent = sentContentsWithKey[keyMatchCount[key]]
                keyMatchCount[key]++

                if (!sentContent) return
                const sentMedia = _.get(sentContent, 'media') || []

                receivedMedia.forEach((media, mediaIndex) => {
                    if (media.type !== 'file' || media.file) return

                    const match = sentMedia[mediaIndex]
                    if (match && match.file) {
                        media.file = _.cloneDeep(match.file)
                    }
                })
            })

            return receivedSection
        },

        saveSection(oldSection, data) {
            this.savingSection = data

            // setTimeout(() => {
            //     this.savingSection = undefined
            //     // this.editSection = undefined
            // }, 1000)

            let areas
            if (data.type === 'grid') {
                areas = _.cloneDeep(data.gridAreas)
                areas.sort((a, b) => a.id - b.id)
                data.gridAreas = data.gridAreas.map((area, i) => {
                    return {
                        id: area.id,
                        key: area.key,
                        name: area.name,
                        row: area.row,
                        column: area.column,
                    }
                })
            }

            this.pageStore.saveSection({
                path: this.path,
                section: data,
            })
                .then(newSection => {
                    this.editSection = undefined

                    if (data.type === 'grid' && areas !== undefined) {
                        newSection.gridAreas.sort((a, b) => a.id - b.id)
                        newSection.gridAreas = newSection.gridAreas.map((area, i) => {
                            const gridItems = _.get(areas, `${i}.gridItems`)
                            if (gridItems) area.gridItems = gridItems
                            return area
                        })
                    }

                    newSection = this.restoreMissingMediaFileData(data, newSection)

                    this.pageStore.replaceSection({ path: this.path, oldSection, newSection })

                    if (!data.id || _.startsWith(data.id, 'new:')) {
                        const sections = this.sections.map(section => {
                            return {
                                id: section.id,
                                position: section.position,
                                type: section.type,
                                area: section.area,
                            }
                        });
                        this.pageStore.saveMultipleSections(sections)
                    }
                })
                .catch(error => {
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Section could not be saved.'),
                        iconClass: 'fas el-icon-fa-xmark',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });

                    // this.$nextTick(() => {
                    //     store.commit('page/sortSections', {
                    //         path: this.path,
                    //         sections: this.sections,
                    //     })
                    // })

                    console.error(error)
                })
                .finally(() => {
                    this.savingSection = undefined
                })
        },
        applySection(oldSection, newSection) {
            this.pageStore.replaceSection({ path: this.path, oldSection, newSection })
            this.editSection = undefined
        },
        openDeleteDialog(data, type = 'section') {
            switch (type) {
                case 'area':
                    if (!data.area.id || _.startsWith(data.area.id, 'new:') || SectionApi.noDeleteDialog(undefined, type) === 'true') {
                        return this.deleteArea(data)
                    }
                    this.deleteDialog.title = this.$t('Delete area')
                    break

                case 'grid':
                case 'section':
                default:
                    if (!data.id || _.startsWith(data.id, 'new:') || SectionApi.noDeleteDialog(undefined, type) === 'true') {
                        return this.deleteSection(data)
                    }
                    if (type === 'grid') this.deleteDialog.title = this.$t('Delete grid')
                    else this.deleteDialog.title = this.$t('Delete section')
                    break
            }

            this.deleteDialog.visibility = true;
            this.deleteDialog.data = data;
            this.deleteDialog.type = type;
        },
        closeDeleteDialog() {
            this.deleteDialog.visibility = false;
            setTimeout(this.resetDeleteDialog, 300);
        },
        resetDeleteDialog() {
            this.deleteDialog.loading = false;
            this.deleteDialog.title = undefined;
            this.deleteDialog.type = 'section';
            this.deleteDialog.remember = false;
            this.deleteDialog.data = undefined;
        },
        deleteElement(type) {
            switch (type) {
                case 'area':
                    this.deleteArea(this.deleteDialog.data)
                    break
                case 'grid':
                case 'section':
                default:
                    this.deleteSection(this.deleteDialog.data)
                    break
            }
        },
        deleteSection(section) {
            if (!section.id || _.startsWith(section.id, 'new:')) {
                this.pageStore.deleteSection({ path: this.path, section })
            } else {
                if (this.deleteDialog.remember) {
                    SectionApi.noDeleteDialog(true, this.deleteDialog.type)
                }

                this.deleteDialog.loading = true;
                this.pageStore.deleteSectionAction({ path: this.path, section })
                    .then(() => {
                        // this.$notify.success({
                        //     title: this.$t('Section has been deleted successfully'),
                        //     iconClass: 'fas el-icon-fa-check',
                        //     position: 'bottom-left',
                        //     customClass: 'dark',
                        //     duration: 8000
                        // });
                        this.closeDeleteDialog();
                    })
                    .catch(() => {
                        this.$notify.error({
                            title: this.$t('Section could not be deleted!'),
                            iconClass: 'fas el-icon-fa-xmark',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    })
                    .finally(() => {
                        this.deleteDialog.loading = false;
                    });
            }
        },
        deleteArea({ area, grid }) {
            // TODO
            // check if this area is the only one in this grid
            // delete the grid if so

            const section = _.cloneDeep(grid)

            if (!area.id || _.startsWith(area.id, 'new:')) {
                // TODO
            } else {
                if (this.deleteDialog.remember) {
                    SectionApi.noDeleteDialog(true, 'area')
                }

                this.deleteDialog.loading = true;
                this.savingSection = grid

                // go through all (sorted) breakpoints
                // and check if there are empty columns / rows
                // without the deleted area

                const remainingAreas = grid.gridAreas.filter(el => el.id !== area.id)

                if (this.breakpoints.length) {
                    const indexes = _.cloneDeep(this.breakpoints)
                        .sort((a, b) => a.value - b.value)
                        .map((el, i) => el.key)

                    const clearEmptySpace = (type = 'column') => {
                        const sorted = _.cloneDeep(grid[type + 's'])
                            .sort((a, b) => indexes.indexOf(b.key) - indexes.indexOf(a.key))

                        sorted.forEach(el => {
                            const breakpoint = el.key

                            // grid config
                            const gc = {
                                rows: getActiveGridConfig(indexes, grid.rows, breakpoint),
                                columns: getActiveGridConfig(indexes, grid.columns, breakpoint),
                            }

                            const gridNode = document.createElement('div')
                            gridNode.style.gridTemplateRows = gc.rows.join(' ')
                            gridNode.style.gridTemplateColumns = gc.columns.join(' ')
                            gridNode.style.display = 'none'
                            // gridNode.classList.add('hidden');

                            // find areas in this row/column
                            // except for the deleted one

                            let valid = true
                            let occupied = []
                            remainingAreas.forEach(ra => {
                                // area config
                                const ac = {
                                    row: getActiveGridConfig(indexes, ra.row, breakpoint),
                                    column: getActiveGridConfig(indexes, ra.column, breakpoint),
                                }

                                if (ac[type] === undefined) {
                                    valid = false
                                    return
                                }

                                const areaNode = document.createElement('div');
                                if (ac.row && _.isArray(ac.row)) areaNode.style.gridColumn = ac.row.join(' ')
                                else areaNode.style.gridRow = ac.row
                                if (ac.column && _.isArray(ac.column)) areaNode.style.gridColumn = ac.column.join(' ')
                                else areaNode.style.gridColumn = ac.column
                                gridNode.appendChild(areaNode);

                                document.body.appendChild(gridNode)
                                const areaStyles = window.getComputedStyle(areaNode)
                                let start = areaStyles.getPropertyValue(`grid-${type}-start`)
                                let end = areaStyles.getPropertyValue(`grid-${type}-end`)
                                document.body.removeChild(gridNode);

                                if (start === 'auto' || parseInt(start) === NaN) {
                                    if (type === 'column') start = 1
                                    else start = this.nth || 1
                                }
                                if (end === 'auto' || parseInt(end) === NaN || end <= start) {
                                    end = parseInt(start) + 1
                                }

                                for (let position = parseInt(start); position < parseInt(end); position++) {
                                    if (!occupied.includes(position)) occupied.push(position)
                                }

                                if (!ra.config) ra.config = {}
                                _.set(ra.config, `${breakpoint}.${type}`, { start: parseInt(start), end: parseInt(end) })
                            })

                            if (valid) {
                                el.options.forEach((option, i) => {
                                    const position = i + 1
                                    if (!occupied.includes(position) && el.options.length > 1) {
                                        // if (! empty.includes(position)) empty.push(position)
                                        el.options.splice(i, 1);

                                        // reorganize remaining grid areas

                                        remainingAreas.forEach(ra => {
                                            const elements = _.get(ra, type) || []
                                            const el = elements.find(el => el.key === breakpoint)

                                            const config = _.get(ra, `config.${breakpoint}.${type}`)
                                            if (config && el) {
                                                if (config.start >= position) config.start -= 1
                                                if (config.end >= position) config.end -= 1

                                                el.value = `${config.start} / ${config.end}`
                                                const span = config.end - config.start
                                                if (span <= 1) el.value = config.start.toString()
                                            }
                                        })
                                    }
                                })
                                el.value = el.options.map(option => option.value).join(' ')
                            }
                        })

                        return sorted
                    }

                    if (grid.columns && grid.columns.length) section.columns = clearEmptySpace('column')
                    if (grid.rows && grid.rows.length) section.rows = clearEmptySpace('row')
                }

                remainingAreas.forEach(ra => delete ra.config)
                section.gridAreas = remainingAreas
            }

            // store.commit('page/form/replaceSection', { path: this.path, oldSection: grid, newSection: section })

            this.saveGrid(section)
        },
        recalculateGridPositions() {
            if (!this.$refs.area) return
            this.areaStyles = window.getComputedStyle(this.$refs.area)
            const refresh = (type = 'row') => {
                if (this.areaStyles && this.activeGridConfig && this.activeGridConfig[type + 's']) {
                    let position = this.gridRowPosition
                    if (type === 'column') position = this.gridColumnPosition

                    let start = this.areaStyles.getPropertyValue(`grid-${type}-start`)
                    const end = this.areaStyles.getPropertyValue(`grid-${type}-end`)

                    if (start === 'auto' || parseInt(start) === NaN) {
                        if (type === 'column') start = 1
                        else start = this.nth || 1
                    }

                    if (end !== 'auto' && parseInt(end) !== NaN && end > start) {
                        position.start = parseInt(start)
                        position.end = parseInt(end)
                    } else {
                        position.start = parseInt(start)
                        position.end = parseInt(start) + 1
                    }

                    position.valid = true
                    position[type + 's'] = []
                    for (let i = position.start; i < position.end; i++) {
                        const el = _.get(this.activeGridConfig[type + 's'], i - 1)
                        if (el) position[type + 's'].push(el)
                        else position.valid = false
                    }
                    position.label = position[type + 's'].join(', ')
                }
            }

            this.gridRowPosition = {
                valid: false,
                label: undefined,
                start: undefined,
                end: undefined,
                rows: [],
            }
            refresh('row')

            this.gridColumnPosition = {
                valid: false,
                label: undefined,
                start: undefined,
                end: undefined,
                columns: [],
            }
            refresh('column')
        },
        // ...mapMutations({
        //     insertSection: `${this.module}/form/addSection`,
        // }),
        // ...mapActions ({
        //     fetchMenuItem: 'menu/fetchMenuItem',
        //     initializeMenuItem: 'menu/initializeMenuItem',
        // }),
    },
    beforeCreate() {
        // this.$options.components.Grid = require('./Grid').default;
        this.$options.components.Grid = Grid
    },
    mounted() {
        this.tippy.forEach(el => {
            if (this.$refs[el.list]) {
                let content = this.$refs[el.list]
                content.style.display = 'block'

                // 'footer:add-section-button'
                if (this.$refs[el.button] && this.$refs[el.button].$el) {
                    el.instance = tippy(this.$refs[el.button].$el, {
                        content,
                        // NOTE: append to body breaks scoped styles and draggable items
                        appendTo: () => document.body,
                        placement: el.placement,
                        interactive: true,
                        allowHTML: true,
                        // boundary: 'viewport',
                        trigger: el.trigger,
                        theme: 'light no-padding',
                        maxWidth: '',
                        zIndex: 2000,
                    });
                }
            }
        })

        if (this.$refs.area) {
            this.recalculateGridPositions()

            const grid = this.$refs.area.closest('.grid');
            if (grid) {
                const style = window.getComputedStyle(grid)
                // console.log('>>', style.getPropertyValue('grid-template-columns'))

                // const gridStyles = window.getComputedStyle(grid)
                // const areaStyles = window.getComputedStyle(this.$refs.area)
                // const rows = {
                //     // style: gridStyles['grid-template-rows'],
                //     values: gridStyles.getPropertyValue('grid-template-rows')
                // }
                // const columns = {
                //     // style: gridStyles['grid-template-columns'],
                //     values: gridStyles.getPropertyValue('grid-template-columns')
                // }
                // console.log(
                //     '>>',
                //     rows,
                //     columns,
                //     areaStyles.getPropertyValue('grid-column-start'),
                //     areaStyles.getPropertyValue('grid-column-end')
                // )
            }

        }

        // ---

        // this.$refs.droppable._sortable.option('onMove', (event) => {
        //     console.log('>>> >> >', _.get(event, 'originalEvent.dataTransfer.items'))
        //     // debugger
        //     return false
        // })

        this._onEscapeKey = this.handleEscapeKey.bind(this)
        window.addEventListener('keydown', this._onEscapeKey)
    },
    beforeDestroy() {
        this.tippy.forEach(el => {
            if (el.instance) setTimeout(el.instance.destroy, 400)
        })

        if (this._onEscapeKey) window.removeEventListener('keydown', this._onEscapeKey)
    },
}

</script>

<style lang="sass" scoped>
.el-alert.unsupported
    margin-bottom: 0
.divider
    display: flex
    align-items: center
    color: rgba(0, 0, 0, 0.4)
    margin: 0.5rem 0
    text-transform: uppercase
    gap: 0.5rem
    hr
        border-top: 1px solid rgba(0, 0, 0, 0.1)
        flex-grow: 1
        &.prefix
            flex-basis: calc(20px - 0.5rem)
            flex-shrink: 0
            flex-grow: 0
.multi-column-list
    padding: 0.5rem
    display: flex
    gap: 1rem
    max-height: 400px
    .options
        display: flex
        flex-direction: column
        .list
            overflow-y: auto

.area-title-bar
    white-space: nowrap

button.option
    .icon
        color: rgba(0, 0, 0, 0.4)

button.option.colored-icon
    &.success
        .icon
            color: $--color-success
        &:active,
        &:focus,
        &:hover
            .icon
                color: darken($--color-success, 10%)
    &.info
        .icon
            color: $--color-info
        &:active,
        &:focus,
        &:hover
            .icon
                color: darken($--color-info, 20%)
    &.warning
        .icon
            color: $--color-warning
        &:active,
        &:focus,
        &:hover
            .icon
                color: darken($--color-warning, 15%)
    &.danger
        .icon
            color: $--color-danger
        &:active,
        &:focus,
        &:hover
            .icon
                color: darken($--color-danger, 15%)

#body .grid-area-drawer .drawer-body
    padding: 0 20px
    .position::v-deep
        .el-form-item__label,
        .el-form-item__error
            padding: 0 20px

.flex-row
    display: flex
    gap: 1rem
    .grow
        flex-grow: 1

.drawer-body
    form
        min-height: 100%
        width: 100%
        display: flex
        flex-direction: column
        .position
            // background-color: $color-body
            margin: 0 -20px
            &.full-height
                min-height: 100%
                display: flex
                flex-direction: column
                justify-content: center
                flex-grow: 1
            .alert
                margin-left: 20px
                margin-right: 20px
.sections::v-deep
    .viewports
        margin-right: 12px
        .el-tooltip
            margin: 0 3px
            color: #9ca3af
            .inner
                text-align: center
</style>
